require('./fiscalDocumentsView.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const Immutable = require('immutable');
// @ commons
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
// @ actions
const documentActions = require('actions/documents');
import additionalDocumentActions from 'actions/additionalDocumentation';
// @ components
const FiscalInformationLinks = require('components/taxAndRents/fiscalInformationLinks/fiscalInformationLinks');
const { ModalCustom } = require('commonsComponents/modalCustom');
const ExtractsList = require('components/myProfile/myProfileExtractsView/myProfileExtractsList/myProfileExtractsList');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { EmptyState } = require('commonsComponents/emptyState');
const FiscalDocumentsFilter = require('components/taxAndRents/fiscalDocumentsFilter/fiscalDocumentsFilter');
// @ constants
const { FISCAL_INFORMATION_GROUP } = require('constants/index');

class FiscalDocumentsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterSettingsOpen: false
        };
        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleResetFilter = this.handleResetFilter.bind(this);
        this.filterDocuments = this.filterDocuments.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.callbackDownloadFile = this.callbackDownloadFile.bind(this);
        this.callbackDownloadFiscalFile = this.callbackDownloadFiscalFile.bind(this);
    }

    componentDidMount() {
        this.props.setGroupSelected(FISCAL_INFORMATION_GROUP);
        this.props.requestMoreDocuments(true);
    }

    componentWillUnmount() {
        this.props.clearFilters();
    }

    setFilter(filters) {
        this.props.setFilter(filters);
        this.props.requestMoreDocuments(true);
    }

    buildContractsView() {
        const { immAccounts, immDocuments, additionalDocuments, requestMoreDocuments } = this.props;
        const groupSelected = immDocuments.get('groupSelected');
        const immFilters = immDocuments.get('filters');
        const immTypes = immDocuments.get('documentsTypes');
        const immGroups = immDocuments.get('documentsGroups');
        const isPartialFetching = immDocuments.get('isPartialFetching');
        const documentsByGroup = immDocuments.get('documentsByGroup');

        let documents = immDocuments.get('documents');
        let documentList;

        if (immDocuments.get('error')) {
            documentList = this.buildErrorState();
        } else {
            documentList = (
                <div>
                    <div className="fiscal-documents-view__filter-settings-button">
                        <OKButton modifier="task" onClick={this.handleToggleFilters}>
                            <i className="icon-filtrar" />
                        </OKButton>
                    </div>
                    <div className="fiscal-documents-view__document-list-section">
                        <ExtractsList
                            immGroups={immGroups}
                            immAccounts={immAccounts}
                            additionalDocuments={additionalDocuments}
                            documents={documents}
                            documentsByGroup={documentsByGroup}
                            requestMoreDocuments={requestMoreDocuments}
                            filters={immFilters}
                            groupSelected={groupSelected}
                            immTypes={immTypes}
                            callbackDownloadFile={this.callbackDownloadFile}
                            callbackDownloadFiscalFile={this.callbackDownloadFiscalFile}
                            isPartialFetching={isPartialFetching}
                            showAutoDates={true}
                            onResetFilter={this.handleResetFilter}
                            onClearFilter={this.handleClearFilters}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="fiscal-documents-view__contracts">
                <ModalCustom
                    extraClass="fiscal-documents-filter__filter-style"
                    isOpen={this.state.filterSettingsOpen}
                    onRequestClose={this.handleToggleFilters}
                    type="filter"
                >
                    <FiscalDocumentsFilter
                        onCloseClick={this.handleToggleFilters}
                        immFilter={immFilters}
                        immTypes={immTypes}
                        setFilter={this.setFilter}
                        groupSelected={groupSelected}
                        immAccounts={immAccounts}
                    />
                </ModalCustom>
                {documentList}
            </div>
        );
    }

    buildDocumentsData(immDocuments) {
        let obj = [];

        if (immDocuments) {
            immDocuments.map(immDocument => {
                let doc = immDocument.toJS();
                doc.file = {
                    filename: `${immDocument.get('nombreTipoComunicacion')}.pdf`,
                    gestorDocumental: immDocument.get('gestorDocumental'),
                    codSubaplicacion: immDocument.get('codSubaplicacion'),
                    codComunicacion: immDocument.get('codComunicacion')
                };
                obj.push(doc);
            });
        }

        return Immutable.fromJS(obj);
    }

    buildErrorState() {
        const errorMessage = formatText('profileExtracts-errorMessage');
        const handleRequestDocuments = this.props.requestDocuments;

        const retryButton = (
            <OKButton
                id="btn_myProfileAdditionalDocumentationView_retry"
                onClick={handleRequestDocuments}
            >
                <FormattedText value="profileExtracts-retry" />
            </OKButton>
        );

        return (
            <OKSectionBox>
                <EmptyState button={retryButton} primaryText={errorMessage} iconType="nointernet-banking"/>
            </OKSectionBox>
        );
    }

    buildHeader() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-taxAndRents'),
                url: '/myprofile/taxAndRents'
            },
            {
                text: formatText('breadcrumb-fiscalDocuments'),
                url: `/myprofile/taxAndRents/fiscalDocuments/`
            }
        ];

        return (
            <OKCover size="medium" section="pg">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={getFinalTitle('breadcrumb-taxAndRents')}
                />
            </OKCover>
        );
    }

    callbackDownloadFile(props) {
        this.props.requestDocumentsPdf({
            filename: props.filename,
            gestorDocumental: props.gestorDocumental,
            codigoSubaplicacion: props.codSubaplicacion,
            codComunicacion: props.codComunicacion
        });
    }

    callbackDownloadFiscalFile(params, filename) {
        this.props.getFileSaddeDocuments(params, filename)
    }

    filterDocuments(documents) {
        const { immDocuments, immAccounts } = this.props;
        const filter = immDocuments.get('filters');
        const hasAccountFilter = filter.getIn(['account', 'isActive']);
        const hasDocumentFilter = filter.getIn(['typeOfDocument', 'isActive']);
        const filterFrom = filter.getIn(['date', 'from'])
            ? filter.getIn(['date', 'from']).format('YYYY-MM-DD')
            : '';
        const filterTo = filter.getIn(['date', 'to'])
            ? filter.getIn(['date', 'to']).format('YYYY-MM-DD')
            : '';
        let contract;
        if (hasAccountFilter) {
            const accountSelected = filter.getIn(['account', 'number']);
            const immAccount = immAccounts.getIn(['byId', accountSelected]);
            contract = immAccount.get('product') + immAccount.get('contractNumber');
        }

        return documents.filter(
            document =>
                (!hasAccountFilter || document.get('numContrato').substring(8) === contract) &&
                document.get('codGrupoComunicacion') === FISCAL_INFORMATION_GROUP &&
                (!hasDocumentFilter ||
                    document.get('codTipoComunicacion') ===
                    filter.getIn(['typeOfDocument', 'type'])) &&
                (!filterFrom || document.get('fechaAlta') >= filterFrom) &&
                (!filterTo || document.get('fechaAlta') <= filterTo)
        );
    }

    handleClearFilters() {
        this.props.clearFilters();
        this.props.requestMoreDocuments(true);
    }

    handleGoToContracts() {
        this.props.history.push('/myprofile/documentation/contracts');
    }

    handleResetFilter(filterKey) {
        this.props.resetFilter(filterKey);
        this.props.requestMoreDocuments(true);
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    render() {
        const header = this.buildHeader();
        const contractsContent = this.buildContractsView();

        return (
            <div className="fiscal-documents-view">
                {header}
                <div className="fiscal-documents-view__body">
                    <div className="col-xs-8">
                        {contractsContent}
                    </div>
                    <div className="col-xs-4">
                        <FiscalInformationLinks />
                    </div>
                </div>
            </div>
        );
    }
}

FiscalDocumentsView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    requestDocuments: PropTypes.func.isRequired,
    requestMoreDocuments: PropTypes.func.isRequired,
    immDocuments: PropTypes.object.isRequired,
    additionalDocuments: PropTypes.object.isRequired,
    setFilter: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setGroupSelected: PropTypes.func.isRequired,
    requestDocumentsPdf: PropTypes.func.isRequired,
    getFileSaddeDocuments: PropTypes.func.isRequired,
};

module.exports.constructor = FiscalDocumentsView;

module.exports.FiscalDocumentsView = connect(
    state => ({
        immAccounts: state.accounts,
        immDocuments: state.documents,
        additionalDocuments: state.additionalDocumentation
    }),
    {
        requestMoreDocuments: documentActions.requestMoreDocuments,
        requestDocuments: documentActions.requestDocuments,
        requestDocumentsPdf: documentActions.requestDocumentsPdf,
        getFileSaddeDocuments: additionalDocumentActions.getFileSaddeDocuments,
        setFilter: documentActions.setDocumentsFilter,
        clearFilters: documentActions.clearDocumentsFilter,
        setGroupSelected: documentActions.setGroupSelected,
        resetFilter: documentActions.resetDocumentsFilter
    }
)(withRouter(FiscalDocumentsView));
